import { dotButtonMarkup } from './dotSvg'

export function renderBullet(index, className) {
  return dotButtonMarkup(className, `Go to slide ${index + 1}`)
}
